<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import uiStore from '../utils/UIStore';
import websocketsStore from '../utils/websocketsStore';

export let debug = false;
export let error = false;
export let warning = false;
export let info = false;

export let keepMessageInSeconds = 5;

let messageList = [];

let uiTexts;
uiStore.textStore.subscribe((store) => {
  uiTexts = store.texts;
});

function dispatch(msg) {
  if (debug && msg.class === 'log-debug') {
    messageList = [msg, ...messageList].filter((msg) => msg.message && msg.message.length > 0);
  }

  if (error && msg.class === 'log-alert') {
    messageList = [msg, ...messageList].filter((msg) => msg.message && msg.message.length > 0);
  }

  if (warning && msg.class === 'log-warning') {
    messageList = [msg, ...messageList].filter((msg) => msg.message && msg.message.length > 0);
  }

  if (info && msg.class === 'log-info') {
    messageList = [msg, ...messageList].filter((msg) => msg.message && msg.message.length > 0);
  }
}

websocketsStore.currentMessage.error.subscribe((msg) => {
  const message = { ...msg, dispatched: new Date() };
  message.class = 'log-alert';
  dispatch(message);
});
websocketsStore.currentMessage.warning.subscribe((msg) => {
  const message = { ...msg, dispatched: new Date() };
  message.class = 'log-warning';
  dispatch(message);
});
websocketsStore.currentMessage.info.subscribe((msg) => {
  const message = { ...msg, dispatched: new Date() };
  message.class = 'log-info';
  dispatch(message);
});
websocketsStore.currentMessage.debug.subscribe((msg) => {
  const message = { ...msg, dispatched: new Date() };
  message.class = 'log-debug';
  dispatch(message);
});
websocketsStore.currentMessage.reset.subscribe(() => {
  messageList = [];
});

//Hide message after 10 seconds; Errors and warning have to closed manually
setInterval(() => {
  const now = new Date();
  messageList = messageList.filter(
    (msg) =>
      msg.type.toLowerCase() === 'error' ||
      msg.type.toLowerCase() === 'warning' ||
      msg.dispatched.getTime() + keepMessageInSeconds * 1000 > now,
  );
}, 1000);

//Close message
function closeMessage(msgToClose) {
  messageList = messageList.filter((msg) => msg !== msgToClose);
}
</script>


<div id="logging" class="toast-message">

    {#each messageList as message}
        <div class="{message.class}" role="alert">
            {message.message}
            <button aria-label="{uiTexts.logging.closeMessageAria}"
                    class="close-toast"
                    on:click={() => closeMessage(message)}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                    <path id="Pfad_10" data-name="Pfad 10"
                          d="M121,108.4l-1.4-1.4-5.6,5.6-5.6-5.6-1.4,1.4,5.6,5.6-5.6,5.6,1.4,1.4,5.6-5.6,5.6,5.6,1.4-1.4-5.6-5.6Z"
                          transform="translate(-107 -107)"/>
                </svg>
            </button>
        </div>
    {/each}

</div>


<style>

    .toast-message {
        position: fixed;
        bottom: 50px;
        left: 0;
        width: 100%;
        z-index: 100;
        padding: 0 20px;
    }

    .toast-message > div {
        padding: 10px 20px 10px 36px;
        border: 5px solid rgba(0, 0, 0, 0.05);
        box-shadow: 0 5px 9px rgba(0, 0, 0, 0.2);
        color: #000;
        width: 100%;
        max-width: 1200px;
        margin: 0 auto 10px;
        background-color: var(--bg-color);
        background-position: 10px center;
    }

    .toast-message .log-debug {
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><path id="icon-info" d="M15,8a7,7,0,1,0,7,7A7,7,0,0,0,15,8Zm0,3.1a1.185,1.185,0,1,1-1.185,1.185A1.185,1.185,0,0,1,15,11.1Zm1.581,7.169a.339.339,0,0,1-.339.339H13.758a.339.339,0,0,1-.339-.339V17.6a.339.339,0,0,1,.339-.339H14.1V15.452h-.339a.339.339,0,0,1-.339-.339v-.677a.339.339,0,0,1,.339-.339h1.806a.339.339,0,0,1,.339.339v2.823h.339a.339.339,0,0,1,.339.339Z" transform="translate(-8 -8)" fill="%23222"/></svg>');
        background-repeat: no-repeat;
    }

    .toast-message .log-info {
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><path id="icon-info" d="M15,8a7,7,0,1,0,7,7A7,7,0,0,0,15,8Zm0,3.1a1.185,1.185,0,1,1-1.185,1.185A1.185,1.185,0,0,1,15,11.1Zm1.581,7.169a.339.339,0,0,1-.339.339H13.758a.339.339,0,0,1-.339-.339V17.6a.339.339,0,0,1,.339-.339H14.1V15.452h-.339a.339.339,0,0,1-.339-.339v-.677a.339.339,0,0,1,.339-.339h1.806a.339.339,0,0,1,.339.339v2.823h.339a.339.339,0,0,1,.339.339Z" transform="translate(-8 -8)" fill="%23222"/></svg>');
        background-repeat: no-repeat;
    }

    .toast-message .log-alert {
        background-color: #FFE1E1;
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="14.001" viewBox="0 0 16 14.001"><path id="icon-alert" d="M8.893,1.5a1.036,1.036,0,0,0-1.773,0L.138,13.5a.98.98,0,0,0,0,1,1.052,1.052,0,0,0,.886.5H14.988a1,1,0,0,0,.877-.5,1.03,1.03,0,0,0,.01-1ZM9.026,13H6.987v-2H9.026Zm0-3H6.987V5.987H9.026Z" transform="translate(-0.001 -1)" fill="%23e00000"/></svg>');
        background-repeat: no-repeat;
    }

    .toast-message .log-warning {
        background-color: #FFF8E1;
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="14.001" viewBox="0 0 16 14.001"><path id="icon-warning" d="M8.893,1.5a1.036,1.036,0,0,0-1.773,0L.138,13.5a.98.98,0,0,0,0,1,1.052,1.052,0,0,0,.886.5H14.988a1,1,0,0,0,.877-.5,1.03,1.03,0,0,0,.01-1ZM9.026,13H6.987v-2H9.026Zm0-3H6.987V5.987H9.026Z" transform="translate(-0.001 -1)" fill="%23e09500"/></svg>');
        background-repeat: no-repeat;
    }

    .toast-message .log-success {
        background-color: #E4FFE1;
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><path id="icon-success" d="M7,0a7,7,0,1,0,7,7A7,7,0,0,0,7,0m4.566,5.9L6.558,10.909a.551.551,0,0,1-.78,0L2.444,7.575a.551.551,0,0,1,0-.78l.87-.87a.552.552,0,0,1,.78,0L6.168,8,9.916,4.251a.551.551,0,0,1,.78,0l.87.87a.551.551,0,0,1,0,.78" fill="%2371b96c"/></svg>');
        background-repeat: no-repeat;
    }

    .toast-message .close-toast {
        width: 1.125rem;
        height: 1.125rem;
        background-position: center center;
        background-size: contain;
        background-color: transparent;
        border: none;
        float: right;
        margin-left: 12px;
        padding: 0;
    }

    .toast-message .close-toast:focus {
        border: 2px solid #000;
    }

</style>